var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLattlast = function SvgLattlast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00263E",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.023 17.847V4.377H4.73v11.182h6.728v2.288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.958 13.9V.43h2.705v11.18h6.728v2.29z"
  }))));
};
export default SvgLattlast;